/**
 * Whether site-manage should show commerce live panels (orders, Pi, offline payments)
 * and kitchen Connect / Pi provision. Marketing / no-backend sites stay quiet.
 * Closes #453.
 */
export function showCommerceLivePanels(opts: {
  ordersEnabled: boolean;
  orderCount: number;
  deviceCount: number;
  paymentCount: number;
}): boolean {
  return (
    opts.ordersEnabled ||
    opts.orderCount > 0 ||
    opts.deviceCount > 0 ||
    opts.paymentCount > 0
  );
}

/** Requests for one tenant from platform usage summary. */
export function tenantRequestCount(
  byTenant: readonly { tenantId: string; requests: number }[] | undefined,
  tenantId: string,
): number | null {
  if (!byTenant || !tenantId) return null;
  const row = byTenant.find((t) => t.tenantId === tenantId);
  return row ? row.requests : 0;
}
